
(function () {
    'use strict';
  
    /* @ngdoc object
     * @name complaints
     * @description
     *
     */
    angular
      .module('cards', [
        'ui.router'
      ]);
  }());
  